import type {HTMLAttributes} from 'react';

import {cn} from '@/utils/tailwind';

export type ContainerWidth = 'text' | 'normal' | 'full';

export type ContainerSpacing = 'none' | 'normal';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
	spacingTop?: ContainerSpacing;
	spacingBottom?: ContainerSpacing;
	width?: ContainerWidth;
}

export const Container = ({
	children,
	spacingTop,
	spacingBottom,
	width,
	className,
	...rest
}: ContainerProps) => {
	let spacingTopClass = 'mt-18 md:mt-36';
	let spacingBottomClass = 'mb-18 md:mb-36';

	switch (spacingBottom) {
		case 'none':
			spacingBottomClass = 'mb-0';
			break;
		case 'normal':
			spacingBottomClass = 'mb-18 md:mb-36';
			break;
	}

	switch (spacingTop) {
		case 'none':
			spacingTopClass = 'mt-0';
			break;
		case 'normal':
			spacingTopClass = 'mt-18 md:mt-36';
			break;
	}

	let widthClass = 'max-w-7xl';
	let paddingClass = 'px-7.5 md:px-18';

	switch (width) {
		case 'normal':
			widthClass = 'max-w-7xl';
			break;
		case 'text':
			widthClass = 'max-w-[840px]';
			break;
		case 'full':
			widthClass = 'w-full';
			paddingClass = 'px-0';
			break;
	}

	return (
		<div
			className={cn(
				[spacingBottomClass, spacingTopClass, paddingClass, 'mx-auto'],
				className,
			)}
			{...rest}
		>
			<div className={cn('mx-auto', widthClass)}>{children}</div>
		</div>
	);
};
